import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { HeroSection } from './Components/HeroSection';
import { Header } from './Components/Header';
import { ChooseUs } from './Components/ChooseUs';
import { TabSection } from './Components/TabSection';
import { PharmacySoftware } from './Components/PharmacySoftware';
import { HealthCare } from './Components/HealthCare';
import { Testimonials } from './Components/Testimonials';
import { Footer } from './Components/Footer';
import { useGetHomeData } from 'hooks';

const HomePage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  const { t } = props;
  let home_data = [];
  /**
   * !This API will call when page set. When response come we are Home Page Data Set
   */
  const { isLoading, data: general_data } = useGetHomeData();
  if (!isLoading) {
    home_data = general_data.data;
  }
  return (
    <>
      {home_data.setting_data && (
        <Helmet>
          <title>AOT Delivery Home</title>
          <meta name="og:title" content={home_data.setting_data.home_page_seo_title} />
          <meta name="title" content={home_data.setting_data.home_page_seo_title} />
          <meta name="description" content={home_data.setting_data.home_page_seo_description} />
          <meta name="og:description" content={home_data.setting_data.home_page_seo_description} />
        </Helmet>
      )}
      <>
        {home_data.setting_data && home_data?.healthcare_data && (
          <Header t={t} setting_data={home_data?.setting_data} />
        )}
        {home_data.setting_data && home_data?.healthcare_data && (
          <HeroSection
            t={t}
            hero_section_data={home_data?.setting_data}
            hero_section_list_data={home_data?.healthcare_data}
          />
        )}
        {home_data.setting_data && home_data?.why_choose_us_data && (
          <ChooseUs
            t={t}
            setting_data={home_data?.setting_data}
            why_choose_us_data={home_data?.why_choose_us_data}
          />
        )}
        {home_data?.why_choose_us_data && (
          <TabSection t={t} why_choose_us_data={home_data?.why_choose_us_data} />
        )}
        {home_data.setting_data && home_data?.pharmacy_software_data && (
          <PharmacySoftware
            t={t}
            setting_data={home_data?.setting_data}
            pharmacy_software_data={home_data?.pharmacy_software_data}
          />
        )}
        {home_data.setting_data && home_data?.healthcare_business_data && (
          <HealthCare
            t={t}
            setting_data={home_data?.setting_data}
            healthcare_business_data={home_data?.healthcare_business_data}
          />
        )}
        {home_data.setting_data && home_data?.healthcare_data && (
          <Testimonials
            t={t}
            setting_data={home_data?.setting_data}
            testimonial_data={home_data?.testimonial_data}
          />
        )}
        {!isLoading && <Footer t={t} />}
      </>
    </>
  );
};
HomePage.propTypes = {
  t: PropTypes.func,
};
export default HomePage;
